import EdiLiveMessageForm from 'sites/forms/EdiLiveMessageForm.vue';
import { videoWizard, typesConfig } from '@/modules/content/config';
import liveMessagesConfig from '@/modules/live-messages/config';
import defaultConfig from '@/modules/redirect/config';

liveMessagesConfig.MessageFormByContentType.live = EdiLiveMessageForm;

videoWizard.allowedMimes = [
  videoWizard.allowedMimes,
  'application/mxf',
].join(',');

defaultConfig.defaultValue.redirectCode = 308;

const EDITypes = {
  blogpost: {
    type: 'blogpost',
    icon: 'text_fields',
    isMedia: false,
    hasWWWPage: true,
  },
  interview: {
    type: 'interview',
    icon: 'text_fields',
    isMedia: false,
    hasWWWPage: true,
  },
  opinion: {
    type: 'opinion',
    icon: 'text_fields',
    isMedia: false,
    hasWWWPage: true,
  },
  opinionvignette: {
    type: 'opinionvignette',
    icon: 'text_fields',
    isMedia: false,
    hasWWWPage: true,
  },
  longform: {
    type: 'longform',
    icon: 'text_fields',
    isMedia: false,
    hasWWWPage: true,
  },
  poll: {
    type: 'poll',
    icon: 'poll',
    isMedia: false,
    hasWWWPage: true,
  },
  external: {
    type: 'external',
    icon: 'open_in_new',
    isMedia: false,
    hasWWWPage: false,
  },
};

Object.assign(typesConfig, EDITypes);
